export const MODAL_DIALOG__ORDER_XCARD = 'MODAL_DIALOG__ORDER_XCARD';
